import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { useWebSocketStatus } from '@/hooks';
import {
    getDatabaseEventName,
    getDatabaseEventTitle,
} from '@/utils/database-event-label';
import type { ReactNode } from 'react';
import type { DatabaseEvent, Event } from '@/types/event';

interface DatabaseEventFeedCardConfig {
    isLive: true;
    isConnected: boolean;
    cardTitle: string;
    itemKey: (databaseEvent: DatabaseEvent) => string;
    itemEvent: (databaseEvent: DatabaseEvent) => Event;
    itemDescription: (databaseEvent: DatabaseEvent) => string;
    itemSubtitle: (databaseEvent: DatabaseEvent) => ReactNode;
    itemConfidence: (databaseEvent: DatabaseEvent) => number | undefined;
    itemCameraName: (
        databaseEvent: DatabaseEvent,
        event: Event,
    ) => string | undefined;
}

export function useDatabaseEventFeedCardConfig(): DatabaseEventFeedCardConfig {
    const { t } = useTranslation(I18nNamespace.EVENTS);
    const isConnected = useWebSocketStatus();

    return {
        isLive: true,
        isConnected,
        cardTitle: '',
        itemKey: (databaseEvent) => databaseEvent.id,
        itemEvent: (databaseEvent) => databaseEvent.event,
        itemDescription: (databaseEvent) =>
            getDatabaseEventName(t, databaseEvent),
        itemSubtitle: (databaseEvent) =>
            getDatabaseEventTitle(t, databaseEvent),
        itemConfidence: (databaseEvent) =>
            databaseEvent.confidence != null
                ? databaseEvent.confidence * 100
                : undefined,
        itemCameraName: (databaseEvent, event) =>
            databaseEvent.sourceName ?? event.sourceName,
    };
}
